import api from '../token';

export const AlterStatusCliente = async (dados) => {
  try {
    const response = await api.post('/alterStatusCliente', dados);
    return response.data;
  } catch (error) {
     
    return { success: false, message: error.message };
  }
};



